module.exports = global["$"] = require("-!/var/www/html/ccinspection/ccinspection-public/node_modules/expose-loader/index.js?jQuery!./jquery.js");